module.exports = "https://www.gc-qa.gnp.com.mx/299c5e44538af9ce38e2835392e9c6e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-contratante-vida.svg
// module id = 8082
// module chunks = 0